export const ACCESS_TOKEN_COOKIE_NAME: string = 'ACCESS_TOKEN';
export const LAWYER_USER_ID_COOKIE_NAME: string = 'LAWYER_USER_ID';
export const REFERRAL_KEY_COOKIE_NAME: string = 'REFERRAL_KEY';
export const GEO_LOCATION_COOKIE_NAME: string = 'JURIK_GEO_LOCATION';
export const CURRENT_CITY_COOKIE_NAME: string = 'JURIK_CURRENT_CITY';
export const JURIK_ERID_COOKIE_NAME: string = 'JURIK_ERID_DATA';
export const COOKIES_ACCEPT_COOKIE_NAME: string = 'JURIK_COOKIES_ACCEPT';
export const COOKIE_MAX_AGE: number = 60 * 60 * 24 * 365;
export const GEO_LOCATION_COOKIE_MAX_AGE: number = 60 * 60 * 24;
export const CURRENT_CITY_COOKIE_MAX_AGE: number = 60 * 60 * 24;
export const JURIK_ERID_COOKIE_MAX_AGE: number = 60 * 60 * 24 * 3;
